import { createTheme } from '@mui/material/styles';

// Quail Game brand colors
const quailGameTheme = createTheme({
  palette: {
    primary: {
      main: '#2E4156', // Header blue color
      light: '#4A6B83',
      dark: '#1E2B3A',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#5A7A95', // Lighter blue for secondary actions
      light: '#7D96AF',
      dark: '#3F5768',
      contrastText: '#ffffff',
    },
    info: {
      main: '#2E4156', // Use primary blue for info elements
    },
    success: {
      main: '#4caf50', // Keep standard green for success
    },
    warning: {
      main: '#ff9800', // Keep standard orange for warnings
    },
    error: {
      main: '#f44336', // Keep standard red for errors
    },
  },
  components: {
    // Customize button styles to use Quail Game colors
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 6,
          [theme.breakpoints.down('sm')]: {
            fontSize: '0.875rem',
            padding: '6px 12px',
            minWidth: 'auto',
          },
        }),
        containedPrimary: {
          backgroundColor: '#2E4156',
          '&:hover': {
            backgroundColor: '#1E2B3A',
          },
        },
      },
    },
    // Customize Paper for mobile
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.down('sm')]: {
            padding: '8px !important',
          },
        }),
      },
    },
    // Customize Container for mobile spacing
    MuiContainer: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.down('sm')]: {
            paddingLeft: '8px',
            paddingRight: '8px',
          },
        }),
      },
    },
    // Improve IconButton touch targets on mobile
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.down('sm')]: {
            minWidth: '44px',
            minHeight: '44px',
            padding: '8px',
          },
        }),
      },
    },
    // Make TableContainer horizontally scrollable on mobile
    MuiTableContainer: {
      styleOverrides: {
        root: ({ theme }) => ({
          [theme.breakpoints.down('sm')]: {
            overflowX: 'auto',
          },
        }),
      },
    },
    // Customize link styles
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#2E4156',
          '&:hover': {
            color: '#1E2B3A',
          },
        },
      },
    },
    // Customize AppBar to ensure consistent header styling
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2E4156',
          color: '#ffffff',
        },
      },
    },
    // Customize Fab (Floating Action Button) colors
    MuiFab: {
      styleOverrides: {
        primary: {
          backgroundColor: '#2E4156',
          '&:hover': {
            backgroundColor: '#1E2B3A',
          },
        },
      },
    },
    // Customize Tab colors
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#2E4156',
          },
        },
      },
    },
    // Customize TabPanel indicator
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#2E4156',
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

export default quailGameTheme;
